import { render, staticRenderFns } from "./formaPagamentoTotais.vue?vue&type=template&id=57b78089"
import script from "./formaPagamentoTotais.vue?vue&type=script&lang=js"
export * from "./formaPagamentoTotais.vue?vue&type=script&lang=js"
import style0 from "./formaPagamentoTotais.vue?vue&type=style&index=0&id=57b78089&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports